import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.bool.isRequired,
  label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {
  required: false,
  label: '',
};

const Checkbox = props => {
  const { name, id, required, value, label, onChange, className, ...rest } = props;

  return (
    <Fragment>
      <input
        {...rest}
        name={name}
        id={id}
        required={required}
        value={value || null}
        label={label}
        checked={value}
        type="checkbox"
        className={clsx(
          className,
          'h-[18px] w-[18px] text-chocolate-600 border-gray-300 focus:ring-gray-300 focus:ring-2 rounded',
        )}
        onChange={onChange ? () => onChange({ target: { name, value: !value } }) : null}
      />

      {label}
    </Fragment>
  );
};

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

export default Checkbox;
